// extracted by mini-css-extract-plugin
export var fileUpload = "_dd-1";
export var modalButton = "_dd-0";